import axiosInstance from "../axiosInstanceSetup";

const BASE_URL = process.env.REACT_APP_API_URL;

const toParam = (val) => (Array.isArray(val) ? val.join(",") : val || undefined);

const exportService = {
  triggerAllSubmissions: async (userId) => {
    const response = await axiosInstance.post(`${BASE_URL}/trigger/all-submissions`, null, {
      params: { user_id: userId },
    });
    return response.data;
  },

  triggerExport: async (productName, userId) => {
    const response = await axiosInstance.post(
      `${BASE_URL}/trigger/product/${encodeURIComponent(productName)}?user_id=${encodeURIComponent(userId)}`
    );
    return response.data;
  },

  triggerAssetExport: async (sharedFilters, localFilters, userId) => {
    const response = await axiosInstance.post(`${BASE_URL}/trigger/asset-scores`, null, {
      params: {
        user_id: userId,
        parentDomain: toParam(sharedFilters.parentDomain),
        domain: toParam(sharedFilters.domain),
        subDomain: toParam(sharedFilters.subDomain),
        product: toParam(sharedFilters.product),
        start_date: sharedFilters.startDate || undefined,
        end_date: sharedFilters.endDate || undefined,
        region: localFilters.region || undefined,
        status: localFilters.status || undefined,
        frequency: localFilters.frequency || undefined,
      },
    });
    return response.data;
  },

  triggerRuleExport: async (sharedFilters, localFilters, userId) => {
    const response = await axiosInstance.post(`${BASE_URL}/trigger/rule-scores`, null, {
      params: {
        user_id: userId,
        parentDomain: toParam(sharedFilters.parentDomain),
        domain: toParam(sharedFilters.domain),
        subDomain: toParam(sharedFilters.subDomain),
        product: toParam(sharedFilters.product),
        start_date: sharedFilters.startDate || undefined,
        end_date: sharedFilters.endDate || undefined,
        rule_name: localFilters.rule_name || undefined,
        dimension_name: localFilters.dimension_name || undefined,
        check_name: localFilters.check_name || undefined,
        status: localFilters.status || undefined,
      },
    });
    return response.data;
  },

  getExportStatus: async (jobId) => {
    const response = await axiosInstance.get(`${BASE_URL}/status/${jobId}`);
    return response.data;
  },
};

export default exportService;
